
class Screen {
  constructor() {
    this.$screen = $(document.documentElement);
    this.$body = $(document.body);
    this.$container = $('#page');

    this._users = [];
    this._isScrollLocked = false;
    this._lastScrollPosition = 0;
  }

  requestScrollDisabled(user, savePosition) {

    this._users.push(user);

    // スクロールが解放されている状態から、ロックする場合
    if(!this._isScrollLocked) {

      // scrollをロックするb前にスクロール量を取得しないと0になる
      this._lastScrollPosition = window.pageYOffset;

      this.$screen.addClass('is-scroll-disabled').css({
        overflow: 'auto',
        height: '100%'
      });
      this.$body.addClass('is-scroll-disabled').css({
        overflow: 'hidden',
        height: '100%'
      });

      if(savePosition) {
        this.$container.css({
          position: 'relative',
          top: -this._lastScrollPosition
        });
      }


      this._isScrollLocked = true;
    }
  }

  requestScrollEnabled(user) {

    // スクロールがすでに解放されていたら何もしない
    if(!this._isScrollLocked) {
      return;
    }

    // 渡されたuserをスクロールロックを利用しているuserを収めている配列の中から探して
    // 存在したら除外する、除外後、配列長0になったら、利用しているユーザーがいないので、スクロールを解放する
    const userIndex = this._users.indexOf(user);

    if(userIndex > -1) {
      this._users.splice(userIndex, 1);
    }

    if(this._users.length === 0) {

      this.$screen.removeClass('is-scroll-disabled').css({
        overflow: '',
        height: ''
      });
      this.$body.removeClass('is-scroll-disabled').css({
        overflow: '',
        height: ''
      });

      this.$container.css({
        position: '',
        top: ''
      });

      window.scrollTo(0, this._lastScrollPosition);

      this._isScrollLocked = false;
    }
  }

}

export default new Screen();



// WEBPACK FOOTER //
// ./src/js/screen.js